export default __webpack_public_path__ + "static/media/Aeonik-Light.3d7faeeb.woff2";